const US = [
  {
    text: 'Alabama',
    key: 'AL',
  },
  {
    text: 'Alaska',
    key: 'AK',
  },
  {
    text: 'American Samoa',
    key: 'AS',
  },
  {
    text: 'Arizona',
    key: 'AZ',
  },
  {
    text: 'Arkansas',
    key: 'AR',
  },
  {
    text: 'California',
    key: 'CA',
  },
  {
    text: 'Colorado',
    key: 'CO',
  },
  {
    text: 'Connecticut',
    key: 'CT',
  },
  {
    text: 'Delaware',
    key: 'DE',
  },
  {
    text: 'District Of Columbia',
    key: 'DC',
  },
  {
    text: 'Florida',
    key: 'FL',
  },
  {
    text: 'Georgia',
    key: 'GA',
  },
  {
    text: 'Guam',
    key: 'GU',
  },
  {
    text: 'Hawaii',
    key: 'HI',
  },
  {
    text: 'Idaho',
    key: 'ID',
  },
  {
    text: 'Illinois',
    key: 'IL',
  },
  {
    text: 'Indiana',
    key: 'IN',
  },
  {
    text: 'Iowa',
    key: 'IA',
  },
  {
    text: 'Kansas',
    key: 'KS',
  },
  {
    text: 'Kentucky',
    key: 'KY',
  },
  {
    text: 'Louisiana',
    key: 'LA',
  },
  {
    text: 'Maine',
    key: 'ME',
  },
  {
    text: 'Marshall Islands',
    key: 'MH',
  },
  {
    text: 'Maryland',
    key: 'MD',
  },
  {
    text: 'Massachusetts',
    key: 'MA',
  },
  {
    text: 'Michigan',
    key: 'MI',
  },
  {
    text: 'Minnesota',
    key: 'MN',
  },
  {
    text: 'Mississippi',
    key: 'MS',
  },
  {
    text: 'Missouri',
    key: 'MO',
  },
  {
    text: 'Montana',
    key: 'MT',
  },
  {
    text: 'Nebraska',
    key: 'NE',
  },
  {
    text: 'Nevada',
    key: 'NV',
  },
  {
    text: 'New Hampshire',
    key: 'NH',
  },
  {
    text: 'New Jersey',
    key: 'NJ',
  },
  {
    text: 'New Mexico',
    key: 'NM',
  },
  {
    text: 'New York',
    key: 'NY',
  },
  {
    text: 'North Carolina',
    key: 'NC',
  },
  {
    text: 'North Dakota',
    key: 'ND',
  },
  {
    text: 'Northern Mariana Islands',
    key: 'MP',
  },
  {
    text: 'Ohio',
    key: 'OH',
  },
  {
    text: 'Oklahoma',
    key: 'OK',
  },
  {
    text: 'Oregon',
    key: 'OR',
  },
  {
    text: 'Pennsylvania',
    key: 'PA',
  },
  {
    text: 'Puerto Rico',
    key: 'PR',
  },
  {
    text: 'Rhode Island',
    key: 'RI',
  },
  {
    text: 'South Carolina',
    key: 'SC',
  },
  {
    text: 'South Dakota',
    key: 'SD',
  },
  {
    text: 'Tennessee',
    key: 'TN',
  },
  {
    text: 'Texas',
    key: 'TX',
  },
  {
    text: 'Utah',
    key: 'UT',
  },
  {
    text: 'Vermont',
    key: 'VT',
  },
  {
    text: 'US Virgin Islands',
    key: 'VI',
  },
  {
    text: 'Virginia',
    key: 'VA',
  },
  {
    text: 'Washington',
    key: 'WA',
  },
  {
    text: 'West Virginia',
    key: 'WV',
  },
  {
    text: 'Wisconsin',
    key: 'WI',
  },
  {
    text: 'Wyoming',
    key: 'WY',
  },
]

const MX = [
  {
    key: 'AG',
    text: 'Aguascalientes',
  },
  {
    key: 'BC',
    text: 'Baja California',
  },
  {
    key: 'BS',
    text: 'Baja California Sur',
  },
  {
    key: 'CH',
    text: 'Chihuahua',
  },
  {
    key: 'CL',
    text: 'Colima',
  },
  {
    key: 'CM',
    text: 'Campeche',
  },
  {
    key: 'CO',
    text: 'Coahuila',
  },
  {
    key: 'CS',
    text: 'Chiapas',
  },
  {
    key: 'DF',
    text: 'Federal District',
  },
  {
    key: 'DG',
    text: 'Durango',
  },
  {
    key: 'GR',
    text: 'Guerrero',
  },
  {
    key: 'GT',
    text: 'Guanajuato',
  },
  {
    key: 'HG',
    text: 'Hidalgo',
  },
  {
    key: 'JA',
    text: 'Jalisco',
  },
  {
    key: 'ME',
    text: 'México State',
  },
  {
    key: 'MI',
    text: 'Michoacán',
  },
  {
    key: 'MO',
    text: 'Morelos',
  },
  {
    key: 'NA',
    text: 'Nayarit',
  },
  {
    key: 'NL',
    text: 'Nuevo León',
  },
  {
    key: 'OA',
    text: 'Oaxaca',
  },
  {
    key: 'PB',
    text: 'Puebla',
  },
  {
    key: 'QE',
    text: 'Querétaro',
  },
  {
    key: 'QR',
    text: 'Quintana Roo',
  },
  {
    key: 'SI',
    text: 'Sinaloa',
  },
  {
    key: 'SL',
    text: 'San Luis Potosí',
  },
  {
    key: 'SO',
    text: 'Sonora',
  },
  {
    key: 'TB',
    text: 'Tabasco',
  },
  {
    key: 'TL',
    text: 'Tlaxcala',
  },
  {
    key: 'TM',
    text: 'Tamaulipas',
  },
  {
    key: 'VE',
    text: 'Veracruz',
  },
  {
    key: 'YU',
    text: 'Yucatán',
  },
  {
    key: 'ZA',
    text: 'Zacatecas',
  },
]

const CA = [
  {
    text: 'Alberta',
    key: 'AB',
  },
  {
    text: 'British Columbia',
    key: 'BC',
  },
  {
    text: 'Manitoba',
    key: 'MB',
  },
  {
    text: 'New Brunswick',
    key: 'NB',
  },
  {
    text: 'Newfoundland and Labrador',
    key: 'NL',
  },
  {
    text: 'Northwest Territories',
    key: 'NT',
  },
  {
    text: 'Nova Scotia',
    key: 'NS',
  },
  {
    text: 'Nunavut',
    key: 'NU',
  },
  {
    text: 'Ontario',
    key: 'ON',
  },
  {
    text: 'Prince Edward Island',
    key: 'PE',
  },
  {
    text: 'Quebec',
    key: 'QC',
  },
  {
    text: 'Saskatchewan',
    key: 'SK',
  },
  {
    text: 'Yukon Territory',
    key: 'YT',
  },
]

export interface StateOption {
  value: string
  label: string
}

export interface StateIndex {
  [key: string]: StateOption[]
}

const getStates = (): Promise<StateIndex> =>
  Promise.resolve({
    US: US.map((x) => ({
      label: x.text,
      value: x.key,
    })),
    MX: MX.map((x) => ({
      label: x.text,
      value: x.key,
    })),
    CA: CA.map((x) => ({
      label: x.text,
      value: x.key,
    })),
  })

export default getStates
